module.exports = __webpack_public_path__ + "static/media/bbraun_logo_white.b28ef633.svg";